<template>
  <div class="mobile dialog" :style="{ visibility: props.modelValue ? 'visible' : 'hidden' }">
    <Transition name="fade">
      <div class="dialog-mask" v-if="props.modelValue">
        <div class="dialog-content" :class="type" :style="{ transform: `scale(${state.scaleRate}) translate(-50%, -50%)`, transformOrigin: 'top left' }">
          <slot></slot>
          <div class="dialog-close close-btn" :class="type" @click="handleClose" v-if="showClose"></div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch, reactive, onMounted } from 'vue'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  type: { // validateUser, common
    type: String,
    required: true
  },
  showClose: {
    type: Boolean,
    default: true
  }
})

const state = reactive({
  scaleRate: 1,
})
// 按16:9的比例计算缩放比例
const calcScaleRate = () => {
  const screenWidth = window.innerWidth
  const screenHeight = window.innerHeight
  if (screenHeight > screenWidth) {
    return 1
  }
  const scaleRate = screenHeight / screenWidth * 16 / 9

  if (scaleRate > 1) {
    return 1
  }
  if (scaleRate < 0.8) {
    return 0.8
  }
  return scaleRate
}
onMounted(() => {
  state.scaleRate = calcScaleRate()
})
watch(() => props.modelValue, (newVal) => {
  if (newVal) {
    document.body.classList.add('lock-scroll')
  } else {
    document.body.classList.remove('lock-scroll')
  }
}, { immediate: true })

const emit = defineEmits(['update:modelValue'])

const handleClose = () => {
  emit('update:modelValue', false)
}
</script>

<style src="./mobile_style.less" lang="less" scoped></style>